import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';
import { instituteMock } from '../data/mock';

const Hero = () => {
  const { hero, contact } = instituteMock;

  const handleSchedule = () => {
    const element = document.getElementById('contact-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleWhatsApp = () => {
    const phone = contact.whatsapp.replace(/\D/g, '');
    window.open(`https://wa.me/55${phone}`, '_blank');
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="grid-two-column">
          <div className="hero-content">
            <h1 className="hero-large">
              <span className="text-gradient">Excelência</span> em saúde ocular com foco em retina
            </h1>
            <p className="body-large">
              {hero.subtitle}
            </p>
            <div className="hero-buttons">
              <button 
                className="btn-primary" 
                onClick={handleSchedule}
              >
                Agendar consulta
              </button>
              <button 
                className="btn-secondary" 
                onClick={handleWhatsApp}
              >
                <Phone size={20} />
                Falar no WhatsApp
              </button>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src={hero.image} 
              alt="Exame oftalmológico moderno" 
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
